module.exports = __webpack_public_path__ + "static/media/raw.af5e4c1a.png";